define('lib/view/FormView',['require','lib/view/LayoutView'],function (require) {

    var LayoutView = require('lib/view/LayoutView');

    /**
     * Form view
     *
     * @class FormView
     */
    return LayoutView.extend({
        
        KEY_ENTER: 13,

        /**
         * Function to combine form data from ui element
         *
         * @param ui
         * @return Object
         * @protected
         */
        _getData: function (ui) {
            if (!ui || !_.isObject(ui)) {
                return {};
            }

            var data = {};
            ui.each(function () {
                if (!jQuery(this).attr('name')) {
                    return;
                }
                if (jQuery(this).attr('type') === 'checkbox') {
                    data[jQuery(this).attr('name')] = jQuery(this).is(':checked');
                } else if (jQuery(this).attr('type') === 'radio') {
                    if (jQuery(this).is(':checked')) {
                        data[jQuery(this).attr('name')] = jQuery(this).val();
                    }
                } else {
                    data[jQuery(this).attr('name')] = jQuery(this).val();
                }
            });

            return data;
        },

        /**
         * Set success message
         *
         * @param String text
         */
        setSuccessMessage: function (text) {
            this._successMessage = text;
        },

        /**
         * Serialize data for form view
         *
         * @return {{errors: (null|any|*), data: *, message: (*|null)}}
         * @protected
         */
        _serializeData: function () {
            var result = {
                'errors': this.model.validationError,
                'data': this.model.toJSON(),
                'message': this._successMessage
            };

            this._successMessage = null;

            return result;
        }

    });

});
